<template>
	<v-container
		fluid
		class="pa-0"
		:class="{
			'no-background': $vuetify.breakpoint.mdAndUp,

			'orange darken-2':
				$route.name == 'PublicProducts' ||
				$vuetify.breakpoint.smAndDown,
			'primary darken-1':
				$route.name != 'HomePage' && $route.name != 'PublicProducts',
		}">
		<v-app-bar
			dark
			style="background-color: rgba(255, 255, 255, 0)"
			elevation="0"
			v-if="$route.name != 'Shipment.PrinterFriendly'">
			<v-app-bar-nav-icon
				v-if="$route.name != 'HomePage'"
				@click.stop="drawer = !drawer"></v-app-bar-nav-icon>
			<v-toolbar-title
				@click="$router.push({ name: 'HomePage' }).catch(() => {})">
				<v-container class="d-none d-md-flex d-lg-flex align-center">
					<img
						class="mx-10"
						src="@/assets/mtl-cargo-logo-2.png"
						style="width: 90px" />

					<span
						style="font-family: 'Sora', sans-serif"
						class="font-weight-black">
						MTL Cargo - Chuyen Hang Ve VN
					</span>
				</v-container>
			</v-toolbar-title>
			<v-spacer></v-spacer>

			<v-spacer></v-spacer>
			<v-btn
				v-if="routeName != 'HomePage' && routeName != 'PublicProducts'"
				class="mx-2 primary"
				depressed
				rounded
				@click="eventBus.$emit('generateCsv')">
				<i class="fa-solid fa-file-arrow-down"></i>
			</v-btn>
			<v-btn
				v-if="routeName != 'HomePage' && routeName != 'PublicProducts'"
				class="mx-2"
				:class="{
					primary: routeName != 'Shipment.Cart',
					warning: routeName == 'Shipment.Cart',
					error: isUpdatingCart == true,
				}"
				depressed
				rounded
				@click="
					$router.push({ name: 'Shipment.Cart' }).catch(() => {})
				">
				<i class="fas fa-shopping-cart mr-2"></i>
				Cart ({{ cartCount }})
			</v-btn>
			<v-btn
				v-if="!isLoggedIn"
				text
				dark
				elevation="0"
				@click="$router.push({ name: 'UserRegister' }).catch(() => {})">
				<i class="fas fa-user-plus mr-2"></i>
				Sign Up
			</v-btn>
			<v-btn
				v-if="!isLoggedIn"
				text
				dark
				elevation="0"
				@click="$router.push({ name: 'Login' }).catch(() => {})">
				<i class="fas fa-sign-in-alt mr-2"></i>
				Login
			</v-btn>

			<v-menu left bottom offset-y min-width="150px" v-if="isLoggedIn">
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon v-bind="attrs" v-on="on">
						<v-icon>mdi-dots-vertical</v-icon>
					</v-btn>
				</template>

				<v-list>
					<v-list-item
						class="blue--text text--darken-2"
						v-if="isLoggedIn && isAdmin"
						@click="$router.push({ name: 'ShipmentManagement' })">
						<v-list-item-title>
							<i class="fas fa-dolly mr-5"></i>
							Shipment Manager
						</v-list-item-title>
					</v-list-item>
					<v-list-item
						class="blue--text text--darken-2"
						v-if="isLoggedIn"
						@click="logout">
						<v-list-item-title>
							<i class="fas fa-sign-out-alt mr-5"></i>
							Logout
						</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>
		<v-navigation-drawer
			v-model="drawer"
			fixed
			temporary
			hide-overlay
			class="main-navigation-drawer">
			<v-list nav dense>
				<v-list-item-group
					active-class="deep-purple--text text--accent-4">
					<v-list-item
						v-for="item in items"
						:key="item.pathName"
						@click="navigateTo(item.pathName)"
						:class="{ 'd-none': item.isRoot && !isRoot }">
						<v-list-item-icon>
							<i :class="item.icon"></i>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>
								{{ item.title }}
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-navigation-drawer>
	</v-container>
</template>
<script>
import eventBus from "@/js/event-bus.js";
import generalMixin from "@/js/general-mixin.js";
import backendService from "@/services/backend-service";
//import backendService from "../services/backend-service";
export default {
	name: "MainNavbar",
	mixins: [generalMixin],
	computed: {
		isRoot() {
			return this.$store.getters["isRoot"];
		},
		cartCount() {
			return this.$store.getters["cartCount"];
		},
		categories() {
			if (
				this.$store.getters["dropdownToOptions"] &&
				this.$store.getters["dropdownToOptions"]["category"]
			)
				return this.$store.getters["dropdownToOptions"]["category"]
					.options;
			return [];
		},
		routeName() {
			return this.$route.name;
		},
		eventBus() {
			return eventBus;
		},
	},
	data() {
		return {
			drawer: false,
			items: [
				{
					pathName: "NewShipment",
					icon: "fas fa-plus",
					title: "New Shipment",
				},
				{
					pathName: "ShipmentList",
					icon: "fas fa-cubes",
					title: "Shipment List",
				},
				{
					pathName: "NewInvoice",
					icon: "fas fa-plus",
					title: "New Invoice",
				},
				{
					pathName: "InvoiceList",
					icon: "fas fa-file-invoice",
					title: "Invoice List",
				},
				{
					pathName: "NewShipmentGroup",
					icon: "fas fa-plus",
					title: "New Shipment Group",
				},
				{
					pathName: "ShipmentGroupList",
					icon: "fas fa-plane-departure",
					title: "Shipment Group List",
				},
				{
					pathName: "CustomerList",
					icon: "fas fa-users",
					title: "Customer List",
				},

				{
					pathName: "VendorList",
					icon: "fas fa-users",
					title: "Vendor List",
				},
				{
					pathName: "NewExpense",
					icon: "fas fa-plus",
					title: "New Expense",
				},
				{
					pathName: "ExpenseList",
					icon: "fas fa-file-invoice",
					title: "Expense List",
				},
				{
					pathName: "PaymentList",
					icon: "fas fa-dollar-sign",
					title: "Payment List",
				},
				{
					pathName: "NewProduct",
					icon: "fas fa-plus",
					title: "New Product",
				},
				{
					pathName: "Shipment.StorePage",
					icon: "fas fa-store",
					title: "Products",
				},
				{
					pathName: "NewStock",
					icon: "fas fa-plus",
					title: "New Stock",
				},

				{
					pathName: "StockList",
					icon: "fas fa-people-carry",
					title: "Stock List",
				},
				{
					pathName: "Shipment.Cart",
					icon: "fas fa-shopping-cart",
					title: "Cart",
				},
				{
					pathName: "Shipment.OrderList",
					icon: "fas fa-th-large",
					title: "Order List",
				},
				{
					pathName: "OverviewDashboard",
					icon: "fas fa-chart-pie",
					title: "Overview Dashboard",
					isRoot: true,
				},
				{
					pathName: "DropdownSetting",
					icon: "fa-solid fa-gear",
					title: "Dropdown Setting",
					isRoot: true,
				},

				{
					pathName: "Shipment.ContactUs",
					icon: "fa-regular fa-address-book",
					title: "Contact Us",
				},
			],
		};
	},
	created: function () {},
	methods: {
		closeNav() {
			document.getElementById("mySidenav").style.width = "0";
			this.showContainer = false;
		},
		openNav() {
			document.getElementById("mySidenav").style.width = "250px";
		},
		showDropdown(dropdown) {
			this.isUncollapsed[dropdown] = !this.isUncollapsed[dropdown];
		},
		logout() {
			backendService;
			this.$router.push({ name: "Logout" }).catch(() => {});
		},
		navigateTo(pathName) {
			this.drawer = false;
			this.$router.push({ name: pathName }).catch(() => {});
		},
		isUpdatingCart() {
			return this.$store.getters["isUpdatingCart"];
		},
	},
};
</script>
<style scoped>
nav .btn {
  color: white;
}
.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  background-color: #3473d9;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
}

.sidenav a,
.dropdown-btn {
  padding: 6px 8px 6px 32px;
  text-decoration: none;
  font-size: 20px;
  color: white;
  display: block;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  outline: none;
}

.sidenav a:hover {
  color: #aaaaaa;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}
.dropdown-container {
  background-color: #516894;
  padding-left: 8px;
}
#categories-dropdown a:first-child {
  font-weight: bold;
}
.brand-title {
  cursor: pointer;
}
.main-navigation-drawer {
  max-height: 100vh;
}
.main-navigation-drawer :deep(.v-navigation-drawer__content) {
  overflow-y: auto;
  overscroll-behavior: contain;
}
.main-navigation-drawer .v-list {
  padding-bottom: 24px;
}
</style>
